// extracted by mini-css-extract-plugin
export var center = "_43-2";
export var clickableRow = "_43-5";
export var expandedRow = "_43-7";
export var hoverable = "_43-4";
export var left = "_43-1";
export var right = "_43-3";
export var row = "_43-0";
export var selectedRow = "_43-6";
export var summaryRow = "_43-8";